export default __webpack_public_path__ + "static/media/button_placement__select_element.36320d88.png";